// extracted by mini-css-extract-plugin
module.exports = {"chevron":"Chevron_chevron__3lqX8","chevronRight":"Chevron_chevronRight__3g4qS","chevronLeft":"Chevron_chevronLeft__sTGG-","open":"Chevron_open__3Rzza"};